import { CharComp } from '@/components/CharComp'
import { TableItem, TableItemCell } from '@/components/TableItem'
import '@/layouts/handicap-real-time-transaction-header.scss'
import classNames from 'classnames'
import dayjs from 'dayjs'
import { useI18n } from 'i18n-utils'
import { useKlineStore } from 'store'
import { useChangeSymbol, useResponsive } from 'store/src/hooks'
import { SocketEventName } from 'store/src/socket/SocketService'
import { useWebSocketStore } from 'store/src/stores/use-web-socket'
import '../styles/real-time-transaction-layout.scss'

export const RealTimeTransaction = defineComponent({
  setup() {
    const { exchangeSocketService } = useWebSocketStore()
    const list = ref<SocketResponse.OrderData[]>([])
    const klineStore = useKlineStore()
    const { t } = useI18n()
    const responsive = useResponsive()

    onMounted(() => {
      exchangeSocketService.onMessage<SocketResponse.OrderResponse>(SocketEventName.Order, (response) => {
        list.value = response.data
      })
    })

    const arrayLength = computed(() => {
      if (responsive.isMobile) {
        return 19
      }
      return 4
    })

    const initList = () => {
      list.value = Array.from({ length: arrayLength.value || 50 }, () => ({
        T: undefined,
        p: '--',
        q: '--',
        s: '--',
        E: 0,
        a: 0,
        m: '',
      }))
    }

    watchEffect(() => {
      if (list.value.length === 0) {
        initList()
      }
    })

    useChangeSymbol(() => {
      initList()
    })

    return () => (
      <div class="real-time-transaction-layout">
        <div class="handicap-real-time-transaction-header">
          <div class="header">
            <div class="header-item">
              <CharComp>{t('时间')}</CharComp>
            </div>
            <div class="header-item">
              <CharComp>
                {t('价格')}({klineStore.getSpotToSymbolName()})
              </CharComp>
            </div>
            <div class="header-item">
              <CharComp>
                {t('数量')}({klineStore.getSpotFromSymbolName()})
              </CharComp>
            </div>
          </div>
        </div>
        <div class={'handicap-real-time-transaction-body real-time-transaction-body show'}>
          {list.value.slice(0, arrayLength.value).map((item, index) => (
            <TableItem key={index}>
              <TableItemCell>
                <CharComp>{item.T ? dayjs(item.T).format('HH:mm:ss') : '--'}</CharComp>
              </TableItemCell>
              <TableItemCell
                class={classNames('table-body-item-cell', {
                  up: item.m !== '0',
                  down: item.m === '0',
                })}
              >
                <CharComp>{item.p.formatNumberWithCommas() || '--'}</CharComp>
              </TableItemCell>
              <TableItemCell>
                <CharComp>{item.q.formatNumberWithCommas() || '--'}</CharComp>
              </TableItemCell>
            </TableItem>
          ))}
        </div>
      </div>
    )
  },
})
